const LANG_STORAGE_NAME = 'currentLanguage'
const CART_STORAGE_NAME = 'currentShoppingCart'
const TOKEN_STORAGE_NAME = 'authToken'
const CLIENT_STORAGE_NAME = 'currentClient'
const DB_LINES_STORAGE_NAME = 'dbOrderLines'
const DB_LINES_RATE = 'dbLinesRate'

/* const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const createCookie = ({ name, value, time = 0, path = '/' }) =>
  document.cookie = `${name}=${value}; expires=${new Date(Date.now() + time).toUTCString()}; path=${path}; secure; SameSite=Strict`

const deleteCookie = name =>
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;` */

/**
 * 
 * @param {string} name 
 * @returns {string|null}
 */
const getLocalStorage = name => localStorage.getItem(name)

/**
 * @param {{name: string, value: string}} param0 
 */
const createLocalStorage = ({ name, value }) => localStorage.setItem(name, value)

/**
 * @param {string} name 
 */
const deleteLocalStorage = name => localStorage.removeItem(name)

export {
  // getCookie, createCookie, deleteCookie,
  getLocalStorage, createLocalStorage, deleteLocalStorage,
  LANG_STORAGE_NAME, CART_STORAGE_NAME, TOKEN_STORAGE_NAME, CLIENT_STORAGE_NAME, DB_LINES_STORAGE_NAME, DB_LINES_RATE
}